<div class="tw:py-4 tw:px-6">
  @if (placementData) {

    <!-- Header -->
    <div class="tw:flex tw:flex-wrap tw:items-center tw:gap-3 tw:mb-3">
      <h3 class="tw:p-0 tw:m-0 tw:flex tw:flex-wrap tw:items-center tw:gap-2">
        {{themeService.siteContent.tutorReportsGroupHeader}}
        <span class="font-14 tag tag--light">{{placementData.subject}}</span>
        @if (placementData.brandName) {
          <span class="font-14 tag tag--light" id="brandBadge">{{placementData.brandName}}</span>
        }
        @if (placementMaintenance?.placementInfo?.deliveryMode) {
          <span class="font-14 tag tag--light" id="deliveryModeBadge">{{placementMaintenance.placementInfo.deliveryMode}}</span>
        }
      </h3>
    </div>

    <!-- Compact meta strip -->
    <div class="ub-meta">
      <div class="ub-meta__item">
        <span class="ub-meta__k">Tutor</span>
        <span class="ub-meta__v" id="tutorname">{{placementData.tutorName}}</span>
      </div>
      <div class="ub-meta__item">
        <span class="ub-meta__k">Type</span>
        <span class="ub-meta__v" id="placementtype">{{placementData.aPorSP}}</span>
      </div>
      <div class="ub-meta__item">
        <span class="ub-meta__k">{{themeService.siteContent.placementIdLabel}}</span>
        <span class="ub-meta__v" id="placementid">{{placementData.placementID}}</span>
      </div>
      <div class="ub-meta__item">
        <span class="ub-meta__k">Booking Dates</span>
        <span class="ub-meta__v">{{placementData.placementStartDate | date : 'dd MMM yyyy'}} &ndash; {{placementData.placementEndDate | date : 'dd MMM yyyy'}}</span>
      </div>
      <!-- programme-overview.orbit-order: internal staff see the Orbit order in place of Group. -->
      @if (orbitOrderCode) {
        <div class="ub-meta__item">
          <span class="ub-meta__k">Order number</span>
          <span class="ub-meta__v" id="orbitOrder">
            @if (orbitOrderUrl) {
              <a [href]="orbitOrderUrl" target="_blank" rel="noopener noreferrer" title="Open this order in Orbit">{{orbitOrderCode}}</a>
            } @else {
              {{orbitOrderCode}}
            }
          </span>
        </div>
      } @else {
        <div class="ub-meta__item">
          <span class="ub-meta__k">Group</span>
          <span class="ub-meta__v" id="studentName">{{placementData.groupName}}</span>
        </div>
      }
    </div>

    <!-- Learners -->
    <div class="ub-learners tw:mt-3">
      <span class="ub-meta__k tw:mr-3">Learners</span>
      <label class="tag-list tw:m-0" id="studentGroupList">
        @for (name of learnerNames; track $index) {
          <div class="tag">{{name}}</div>
        }
      </label>
    </div>

  }
</div>
